import { RefreshCw } from 'lucide-react'
import { useApi, asArray } from '../../hooks/useApi'

interface QueueEntry {
  computedScore: number
  projectCount: number
  searchCount: number
  globalKeyword: {
    keyword: string
    lastSerpUpdate: string | null
    volume: number | null
  }
}

function formatDate(dateStr: string | null): string {
  if (!dateStr) return 'Jamais'
  const d = new Date(dateStr)
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
}

export default function GlobalDbRefreshQueue() {
  const { data, loading } = useApi<QueueEntry[]>('/api/admin/global-db/refresh-queue?limit=20')
  const entries = asArray(data)

  return (
    <div className="bg-white rounded-xl border border-[#E2E4ED] p-5">
      <div className="flex items-center gap-2 mb-4">
        <RefreshCw size={18} strokeWidth={1.25} className="text-[#6366F1]" />
        <h2 className="text-lg font-semibold text-[#1B2559]">File de rafraichissement</h2>
      </div>

      {loading ? (
        <div className="space-y-3">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="animate-pulse bg-[#E2E4ED] rounded h-8 w-full" />
          ))}
        </div>
      ) : entries.length === 0 ? (
        <p className="text-sm text-[#8B8FA7]">Aucun mot-cle en attente de refresh</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[#8B8FA7] border-b border-[#E2E4ED]">
                <th className="pb-2 font-medium">Keyword</th>
                <th className="pb-2 font-medium text-right">Volume</th>
                <th className="pb-2 font-medium text-right">Score</th>
                <th className="pb-2 font-medium text-right">Dernier refresh</th>
              </tr>
            </thead>
            <tbody>
              {entries.map((entry, i) => (
                <tr key={i} className="border-b border-[#E2E4ED] last:border-0">
                  <td className="py-2 font-medium text-[#1B2559]">
                    {entry.globalKeyword.keyword}
                  </td>
                  <td className="py-2 text-right text-[#8B8FA7]">
                    {entry.globalKeyword.volume?.toLocaleString('fr-FR') ?? '-'}
                  </td>
                  <td className="py-2 text-right">
                    <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-700">
                      {entry.computedScore.toFixed(1)}
                    </span>
                  </td>
                  <td className="py-2 text-right text-[#8B8FA7]">
                    {formatDate(entry.globalKeyword.lastSerpUpdate)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
